import AbstractModel from './AbstractModel';
import {IWorkSchedule} from '@src/@interfaces/services/Database/IWorkSchedule';
import {IReduxAppState} from '@src/@interfaces';

export default class WorkSchedule extends AbstractModel<IWorkSchedule> implements IWorkSchedule {
    readonly key!: keyof IReduxAppState['workSchedule'];
    readonly value!: any;

    protected get table() {
        return this.connection.workSchedule;
    }
}
